
// import React, { useRef,useState, useEffect } from "react";
// import {
//   Box,
//   Typography,
//   Container,
//   Link,
//   useMediaQuery,
//   useTheme
// } from "@mui/material";
// import {  Row, Col, Carousel } from 'react-bootstrap';

// import { useSwipeable } from "react-swipeable";
// import NavBar from "./NavBar";
// import Section1 from "./Section1";
// import WhoWeServe from "./WhoWeServe";
// import WhatWeDo from "./WhatWeDo";
// import Testimonials from "./Testimonials";
// import Footer from "./Footer";
// import Hero1 from "../Assests/Hero1.png";
// import Hero2 from "../Assests/Hero2.png";
// import Hero3 from "../Assests/Hero3.png";
// import Hero4 from "../Assests/Hero4.png";
// import AOS from "aos";
// import "aos/dist/aos.css";

// const Home = () => {
//   // const images = [Hero1, Hero2, Hero3, Hero4];
 
//   const heroSlides = [
//      {
//     image: "https://media.gettyimages.com/id/2090614355/photo/creative-brainstorming-session.jpg?s=612x612&w=0&k=20&c=csC4D2o_XEXQ6Qtoq7G281r2jsU8MfbN1IEwnMwmsiw=",
//   },
//   {
//     image: "https://media.gettyimages.com/id/1405279677/photo/close-up-of-people-pointing-to-a-graph-with-data.jpg?s=612x612&w=0&k=20&c=lHfL85whQ8l18-kK3tPYl5SveS-pnJ2COQtJmyreQ3A=",
//   },
//   {
//     image: "https://media.gettyimages.com/id/1413884808/photo/business-colleagues-in-a-meeting-or-financial-advisor-or-lawyer-with-couple-explaining-options.jpg?s=612x612&w=0&k=20&c=uTrp_LWEsS10GUTCbGyGxF2O45DDr5m_Nt4NboEIk04=",
//   },
//   {
//     image:"https://media.gettyimages.com/id/1450961393/video/closeup-group-of-asian-business-people-meeting-discuss-project-plan-and-financial-results-in.jpg?s=640x640&k=20&c=SEVSiuaOKyXezX4J79arc6LAE422ujP9ATiO77TlE3A=",
//   },
//   ];

//   const scrollRef = useRef(null);

//   useEffect(() => {
//     AOS.init({ duration: 1000, once: true });

//     // Auto-scroll horizontally every 3s
//     const scrollContainer = scrollRef.current;
//     let index = 0;

//     const interval = setInterval(() => {
//       if (scrollContainer) {
//         index = (index + 1) % heroSlides.length;
//         scrollContainer.scrollTo({
//           left: index * window.innerWidth, // scroll by screen width
//           behavior: "smooth",
//         });
//       }
//     }, 3000);

//     return () => clearInterval(interval);
//   }, [heroSlides.length]);

  

//   return (
//     <div>
//       <NavBar />

//       {/* Hero Image Slider */}
//           <section style={{ position: "relative", width: "100%", height: "80vh" }}>
//         <div
//           ref={scrollRef}
//           style={{
//             display: "flex",
//             overflowX: "hidden",
//             scrollBehavior: "smooth",
//             width: "100%",
//             height: "100%",
//             marginTop:'40px',
//           }}
//         >
//           {heroSlides.map((slide, index) => (
//             <div
//               key={index}
//               style={{
//                 minWidth: "100%", // take full width of viewport
//                 height: "80vh",
//                 backgroundImage: `url(${slide.image})`,
//                 backgroundSize: "cover",
//                 backgroundPosition: "center",
//                 position: "relative",
//               }}
//             >
//               {/* Overlay */}
//               <div
//                 style={{
//                   position: "absolute",
//                   top: 0,
//                   left: 0,
//                   right: 0,
//                   bottom: 0,
//                   background: "rgba(0,0,0,0.5)",
//                   display: "flex",
//                   justifyContent: "center",
//                   alignItems: "center",
//                   color: "white",
//                   textAlign: "center",
//                 }}
//               >
//                 <Container fluid>
//                   <Row className="justify-content-center align-items-center">
//                     <Col lg={8}>
//                       {/* You can add heading/text here if needed */}
//                     </Col>
//                   </Row>
//                 </Container>
//               </div>
//             </div>
//           ))}
//         </div>
//       </section>

//       {/* Sections */}
//       <Section1 />
//       <WhoWeServe />
//       <WhatWeDo />
//       <Testimonials />

//       {/* Get in Touch */}
//       <Box sx={{ bgcolor: "#eae9e9ff", py: 8 }}>
//         <Container maxWidth="md" sx={{ textAlign: "center" }}>
//           <Typography
//             variant="h4"
//             sx={{
//               fontWeight: "bold",
//               color: "#00B140",
//               mb: 1,
//               fontFamily: "Roboto, sans-serif",
//             }}
//           >
//             GET IN TOUCH
//           </Typography>

//           <Link
//             href="mailto:devarajuassociates@gmail.com"
//             underline="none"
//             sx={{
//               color: "#00B140",
//               fontWeight: "bold",
//               fontSize: "1.4rem",
//               "&:hover": { textDecoration: "underline" },
//             }}
//           >
//             INFO@PDNANDASSOCIATES.COM
//           </Link>
//         </Container>
//       </Box>

//       <Footer />
//     </div>
//   );
// };

// export default Home;























// import React, { useRef, useEffect } from "react";
// import {
//   Box,
//   Typography,
//   Container,
//   Link,
// } from "@mui/material";
// import { Row, Col } from 'react-bootstrap';
// import NavBar from "./NavBar";
// import Section1 from "./Section1";
// import WhoWeServe from "./WhoWeServe";
// import WhatWeDo from "./WhatWeDo";
// import Testimonials from "./Testimonials";
// import Footer from "./Footer";
// import AOS from "aos";
// import "aos/dist/aos.css";

// const Home = () => {
//   const heroSlides = [
//     {
//       image: "https://media.gettyimages.com/id/2090614355/photo/creative-brainstorming-session.jpg?s=2048x2048&w=0&k=20&c=csC4D2o_XEXQ6Qtoq7G281r2jsU8MfbN1IEwnMwmsiw=",
//       alt: "Creative brainstorming session",
//     },
//     {
//       image: "https://media.gettyimages.com/id/1457948354/photo/successful-businesswoman-in-modern-office-working-on-laptop.jpg?s=612x612&w=0&k=20&c=V0GfbpDTpyD7oLP_jg9dCibf4SzOWQml2jC-vYc7YhE=",
//       alt: "People analyzing data graph",
//     },
//     {
//       image: "https://media.gettyimages.com/id/1413884808/photo/business-colleagues-in-a-meeting-or-financial-advisor-or-lawyer-with-couple-explaining-options.jpg?s=2048x2048&w=0&k=20&c=uTrp_LWEsS10GUTCbGyGxF2O45DDr5m_Nt4NboEIk04=",
//       alt: "Business meeting with colleagues",
//     },
//     {
//       image: "https://media.gettyimages.com/id/1450961393/photo/closeup-group-of-asian-business-people-meeting-discuss-project-plan-and-financial-results-in.jpg?s=2048x2048&w=0&k=20&c=SEVSiuaOKyXezX4J79arc6LAE422ujP9ATiO77TlE3A=",
//       alt: "Asian business team discussing project",
//     },
//   ];

//   const scrollRef = useRef(null);

//   useEffect(() => {
//     AOS.init({ duration: 1000, once: true });

//     // Preload images to ensure HD quality
//     heroSlides.forEach((slide) => {
//       const img = new Image();
//       img.src = slide.image;
//     });

//     // Auto-scroll horizontally every 3s
//     const scrollContainer = scrollRef.current;
//     let index = 0;

//     const interval = setInterval(() => {
//       if (scrollContainer) {
//         index = (index + 1) % heroSlides.length;
//         scrollContainer.scrollTo({
//           left: index * window.innerWidth,
//           behavior: "smooth",
//         });
//       }
//     }, 3000);

//     return () => clearInterval(interval);
//   }, [heroSlides.length]);

//   return (
//     <div>
//       <NavBar />

//       {/* Hero Image Slider */}
//       <section style={{ position: "relative", width: "100%", height: "80vh", overflow: "hidden" }}>
//         <div
//           ref={scrollRef}
//           style={{
//             display: "flex",
//             overflowX: "hidden",
//             scrollBehavior: "smooth",
//             width: "100%",
//             height: "100%",
//             marginTop: '40px',
//           }}
//         >
//           {heroSlides.map((slide, index) => (
//             <div
//               key={index}
//               style={{
//                 minWidth: "100%",
//                 height: "80vh",
//                 position: "relative",
//                 display: "flex",
//                 justifyContent: "center",
//                 alignItems: "center",
//               }}
//             >
//               <img
//                 src={slide.image}
//                 alt={slide.alt}
//                 style={{
//                   width: "100%",
//                   height: "100%",
//                   objectFit: "cover",
//                   objectPosition: "center",
//                   display: "block",
//                   imageRendering: "-webkit-optimize-contrast", // Enhances image clarity
//                 }}
//                 loading="lazy"
//               />
//               {/* Overlay */}
//               <div
//                 style={{
//                   position: "absolute",
//                   top: 0,
//                   left: 0,
//                   right: 0,
//                   bottom: 0,
//                   background: "rgba(0,0,0,0.5)",
//                   display: "flex",
//                   justifyContent: "center",
//                   alignItems: "center",
//                   color: "white",
//                   textAlign: "center",
//                 }}
//               >
//                 <Container fluid>
//                   <Row className="justify-content-center align-items-center">
//                     <Col lg={8}>
//                       {/* Add heading/text here if needed */}
//                     </Col>
//                   </Row>
//                 </Container>
//               </div>
//             </div>
//           ))}
//         </div>
//       </section>

//       {/* Sections */}
//       <Section1 />
//       <WhoWeServe />
//       <WhatWeDo />
//       <Testimonials />

//       {/* Get in Touch */}
//       <Box sx={{ bgcolor: "#eae9e9ff", py: 8 }}>
//         <Container maxWidth="md" sx={{ textAlign: "center" }}>
//           <Typography
//             variant="h4"
//             sx={{
//               fontWeight: "bold",
//               color: "#00B140",
//               mb: 1,
//               fontFamily: "Roboto, sans-serif",
//             }}
//           >
//             GET IN TOUCH
//           </Typography>

//           <Link
//             href="mailto:devarajuassociates@gmail.com"
//             underline="none"
//             sx={{
//               color: "#00B140",
//               fontWeight: "bold",
//               fontSize: "1.4rem",
//               "&:hover": { textDecoration: "underline" },
//             }}
//           >
//             INFO@PDNANDASSOCIATES.COM
//           </Link>
//         </Container>
//       </Box>

//       <Footer />
//     </div>
//   );
// };

// export default Home;













import React, { useState, useEffect, useRef } from "react";
import { motion, AnimatePresence } from 'framer-motion';
import {
  Box,
  Typography,
  Container,
  Link,
} from "@mui/material";
import { Row, Col } from 'react-bootstrap';
import NavBar from "./NavBar";
import Section1 from "./Section1";
import WhoWeServe from "./WhoWeServe";
import WhatWeDo from "./WhatWeDo";
import Testimonials from "./Testimonials";
import Footer from "./Footer";
import AOS from "aos";
import "aos/dist/aos.css";
// import ClubHouse from "../Assests/ClubHouse.jpg";
import H1 from "../Assests/H1.png";
import H2 from "../Assests/H2.png";
import H3 from "../Assests/H3.png";
import H4 from "../Assests/H4.png";
import H5 from "../Assests/H5.png";


const Home = () => {
  const images = [
    // "https://media.gettyimages.com/id/1785631455/photo/successful-deal-with-insurance-agent.jpg?s=612x612&w=0&k=20&c=ae2ppXOU9thXaBka3r7dg27fxdqG-DB5IGJlYfCdq7g=",
    H1,H3,H4
  ];
  const [current, setCurrent] = useState(0);

  /* ------------ Helpers ------------ */
  const nextSlide = () => setCurrent((prev) => (prev + 1) % images.length);

  /* ------------ Auto-rotate ------------ */
  const timerRef = useRef(null);
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });

    // Preload images to ensure HD quality
    images.forEach((img) => {
      const imgPreload = new Image();
      imgPreload.src = img;
    });

    // Auto-scroll every 4s
    timerRef.current && clearInterval(timerRef.current);
    timerRef.current = setInterval(nextSlide, 4000);
    return () => clearInterval(timerRef.current);
  }, [current]);

  /* ------------ Variants ------------ */
  const variants = {
    enter: { opacity: 0, scale: 0.1 },
    center: { opacity: 1, scale: 1 },
    exit: { opacity: 0, scale: 1.4 },
  };

  return (
    <div>
      <NavBar />

      {/* Hero Image Slider */}
      <div className="slide-wrapper">
        <style>{`
          .slide-wrapper { position: relative; 
          width: 100%;
           max-width: 100%;
           height: 580px; 
           margin: 90px auto 0; 
           overflow: hidden; 
          //  border-radius: 5px; 
          margin-Top:-10px
         
            }

          @media (max-width: 767px) {
            .slide-wrapper {
              height: 320px;
              margin: 60px auto 0;
              
            }
          }

          .slide-wrapper img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            display: block;
            position: absolute;
            top: 0;
            left: 0;
            image-rendering: -webkit-optimize-contrast;
            
          }

          .slide-overlay {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(0,0,0,0.5);
            display: flex;
            justify-content: center;
            align-items: center;
            color: white;
            text-align: center;
            
          }
        `}</style>

        <AnimatePresence initial={false}>
          <motion.img
            key={current}
            src={images[current]}
            alt={`Slide ${current + 1}`}
            variants={variants}
            initial="enter"
            animate="center"
            exit="exit"
            transition={{ duration: 0.8, ease: 'easeInOut' }}
          />
        </AnimatePresence>
      </div>

  {/* <div
  style={{
    position: "relative",
    width: "100%",
    maxWidth: "100%",
    height: "580px",
    overflow: "hidden",
    borderRadius: "1px",
    // margins
    marginLeft: "auto",
    marginRight: "auto",
    marginTop: "-5px",
    marginBottom: 0
  }}
>
  <AnimatePresence initial={false}>
    <motion.img
      key={current}
      src={images[current]}
      alt={`Slide ${current + 1}`}
      variants={variants}
      initial="enter"
      animate="center"
      exit="exit"
      transition={{ duration: 0.8, ease: "easeInOut" }}
      style={{
        width: "100%",
        height: "580px",
        objectFit: "cover",
        display: "block",
        position: "absolute",
        top: 0,
        left: 0,
        imageRendering: "-webkit-optimize-contrast"
      }}
    />
  </AnimatePresence>
</div> */}









      {/* Sections */}
      <Section1 />
      <WhoWeServe />
      <WhatWeDo />
      <Testimonials />

      {/* Get in Touch */}
      <Box sx={{ bgcolor: "#00B140", py: 8 }}>
        <Container maxWidth="md" sx={{ textAlign: "center" }}>
          <Typography
            variant="h4"
            sx={{
              fontWeight: "bold",
              color: "#fff",
              mb: 1,
              fontFamily: "Roboto, sans-serif",
            }}
          >
            GET IN TOUCH
          </Typography>

          <Link
            href="mailto:devarajuassociates@gmail.com"
            underline="none"
            sx={{
              color: "#fff",
              fontWeight: "bold",
              fontSize: "1.4rem",
              "&:hover": { textDecoration: "underline",color:'#023E62' },
            }}
          >
            INFO@PDNANDASSOCIATES.COM
          </Link>
        </Container>
      </Box>

      <Footer />
    </div>
  );
};

export default Home;